import { Controller } from "@hotwired/stimulus"

import { gsap } from "gsap"

export default class extends Controller {
  static targets = [ "navicon", "searchTrigger", "searchPanel", "searchForm" ]

  initialize() {
    // console.log("Hello from newsletter!", this.element)
  }

  toggle(){
    // console.log('yoyo')
  }


  disconnect(){
    // console.log('bye bye')
  }
}